export default __webpack_public_path__ + "25af10c89ea0e1c03e49eba759ac8648.ttf";